import { LineItem } from "@made-people/grease-cart";

type WarehouseStockMap = Record<string, Record<string, number>>;

export const isAnyCartItemInWarehouse = (
  items: LineItem[],
  warehouseId: string,
  cartWarehouseStock?: WarehouseStockMap,
): boolean => {
  for (const item of items) {
    if (item.type !== "product") {
      continue;
    }

    const product = item.product;

    if (
      product.dataModel !== "with_variants" &&
      product.dataModel !== "simple"
    ) {
      continue;
    }

    const fromContext = cartWarehouseStock?.[item.id];
    if (fromContext && (fromContext[warehouseId] ?? 0) > 0) {
      return true;
    }
  }

  return false;
};
